module.exports = __webpack_public_path__ + "static/logo-concrete-content-8961deefffbc820151b70de328b101ee.svg";